export default function Loading(){
  return(
    <button className="btn btn-lg loading">loading</button>
  );
}
